'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function SignUpComponent() {
  var _this3 = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.priority = 1001;
  this._submitButton = null;
  this._session = new Session();
  this.extends = [_Paths, _AnalyticsData, PartnerAttribution, SessionUtm];
  this.referrerCode = null;
  this.referralOriginUrl = null;
  this.dataSanitization = new DataSanitization();
  this.formVersion = 'Short';
  this._viewMaps = {};

  this.init = function () {
    this._node = $(this.node);
    this._form = this.node.querySelector('.js--signup-form');
    this.newEmail = this._node.find('.js--username');
    this.emailSuggestion = this._node.find('.js--email-suggestion');
    this.agreementCheckbox = this._node.find('.js--agreement-checkbox');
    this.attributionCodeFields = this.node.querySelectorAll('.js--attribution-code');
    this.attributionIdFields = this.node.querySelectorAll('.js--attribution-id');

    // Event Listeners
    this.newEmail.on('blur', this.trimUsername.bind(this));

    this.analytics = new Analytics();
    this.analytics.update(this.analyticsData, this);
    var validationSchema = this.formVersion === 'Extended' ? '/schemas?filter=signup_extended' : '/schemas?filter=signup';

    var schemaReq = new APIRequest(validationSchema, 'GET', null, this._onGetSchema.bind(this), null, this.formVersion !== 'Extended');
    schemaReq.send();

    if (this.formVersion === 'Extended') {
      this.addressValues = '';
      this.canadaPostId = '';
      this.validPostalCode = false;

      this._$formInputs = {
        // Address Fields
        address: this._node.find('.js--form-address'),
        streetNumber: this._node.find('.js--form-street-number'),
        streetName: this._node.find('.js--form-street-name'),
        city: this._node.find('.js--form-city'),
        apartment: this._node.find('.js--form-apartment'),
        province: this._node.find('.js--form-province'),
        postalCode: this._node.find('.js--form-postal-code'),
        country: this._node.find('.js--form-country'),
        // Dob
        birthDate: this._node.find('.js--form-birth-date'),
        // Canada Post Id (Hidden field)
        canadaPostId: this._node.find('.js--form-canada-post-id'),
        // Other hidden fields
        hiddenAddressField: this._node.find('.hidden-address-field')
      };

      // Form text
      this._cantFindAddressText = this._node.find('.cant-find-address'),
      // Manual Entry Link
      this._cantFindAddressLink = this._cantFindAddressText.find('.cant-find-address-link');
      // Confirm Address / Manually enter address prompt
      this._addressFieldsPrompt = this._node.find('.marketing-sign-up-extended--address-fields-prompt');

      /*
        This list ensures entered postal code is from the province selected
        See: https://mogofintech.atlassian.net/browse/ACCT-752
      */
      this.provincePostalCodeList = {
        AB: { name: 'Alberta', letter: ['T'] },
        BC: { name: 'British Columbia', letter: ['V'] },
        MB: { name: 'Manitoba', letter: ['R'] },
        NB: { name: 'New Brunswick', letter: ['E'] },
        NL: { name: 'Newfoundland & Labrador', letter: ['A'] },
        NS: { name: 'Nova Scotia', letter: ['B'] },
        NT: { name: 'Northwest Territories', letter: ['X'] },
        NU: { name: 'Nunavut', letter: ['X'] },
        ON: { name: 'Ontario', letter: ['K', 'L', 'M', 'N', 'P'] },
        PE: { name: 'Prince Edward Island', letter: ['C'] },
        QC: { name: 'Quebec', letter: ['G', 'H', 'J'] },
        SK: { name: 'Saskatchewan', letter: ['S'] },
        YT: { name: 'Yukon', letter: ['Y'] }
      };

      this._setupCanadaPostAutocomplete();

      this.presenter = new APIPresenter();
      this.presenter.extendViewMap(this._viewMaps);
    }

    this.setPartnerAttribution();
    this.setSessionUtm();

    this._node.css('display', 'block');

    this._disableSubmitOnEnter();
  };

  this.initAllReady = function () {
    this._signUpForm = this._node.find('.js--signup-form');
    this._submitButton = this._node.find('.button').show();
    this._node.off('keyup.blocksubmit keypress.blocksubmit keydown.blocksubmit');
    // Pop Up sign up and header form, both are same file and called twice in the page. the only difference is their ID.
    // Whenever email suggestion trigger it show up in both. By adding ID to inputSelector we just limit it to one form
    if (this.emailSuggestion.length > 0) {
      this.emailSuggestion.mogo().create('EmailSuggestion', {
        inputSelector: '#' + this.id + ' .js--username'
      });
    }
  };

  this.trimUsername = function (e) {
    var str = $(e.target).val();
    var trimmedStr = str.trim();
    return $(e.target).val(trimmedStr);
  };

  this._onGetSchema = function (data, response, status) {
    var _this2 = this;

    if (response === 200) {
      var schema = JSON.parse(data[0].schema);

      // PW: I think we can keep support for promo and referrer in this form, or is there problem?
      // if (this.formVersion !== 'Extended') {
      // bypass validation because we cannot use assertions with optional fields
      // ? what does that comment mean...
      delete schema.properties.promo_code;
      delete schema.properties.referrer_code;
      // }

      if (this.formVersion === 'Extended') {
        // remove FE validation for birthday since we don't have a quick way to sanatize it on the fly
        // user always uses the UI to select date, so if its not blank it should always be YYYY/MM/DD format
        delete schema.properties.birth_date;
      }

      $('form', this.node).mogo().create('SchemaValidation', {
        schema: schema,
        onSubmit: this._onValidate.bind(this)
      });

      this.agreementCheckbox.on('focusout change', function () {
        _this2.agreementCheckbox.mogo().hideErrorLabel();
      });
    } else {
      this._setButtonLoadState(false);
    }
  };

  this._validateAgreementCheckbox = function () {
    var checkboxContainer = this.agreementCheckbox.find('.mogo-ui-checkbox');
    if (checkboxContainer && !checkboxContainer.hasClass('selected')) {
      this.agreementCheckbox.mogo().showErrorLabel();
      this.analytics.pushEvent('form-errors', {
        FormErrors: ['checkbox']
      });
      return false;
    }
    this.agreementCheckbox.mogo().hideError();
    return true;
  };

  this._setButtonLoadState = function (disabled, index) {
    // this code wont work for more than 2 submit form in a page
    for (index in this._submitButton) {
      if (index < 2 === true) {
        if (disabled) {
          this._submitButton[index].mogo().setDisabledLoadState();
        } else {
          this._submitButton[index].mogo().removeDisabledLoadState();
        }
      }
    }
  };

  this._disableSubmitOnEnter = function () {
    // don't let users submit the form using the enter key until we ready.
    $(this.node).on('keyup.blocksubmit keypress.blocksubmit keydown.blocksubmit', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });
  };

  this._segmentTrackAccountCreated = function (data) {
    var _window = window,
        analytics = _window.analytics;
    var member_uuid = data.member_uuid;


    try {
      analytics.identify(member_uuid, {
        userId: member_uuid,
        signup_platform: 'web'
      });
    } catch (e) {
      console.warn('>>> Error: ' + e);
    }
  };
  this._scrollTopToBottom = function (currentErrPosition) {
    var currentErrPlusHeader = currentErrPosition - 100;
    var currentViewPosition = $(window).scrollTop();
    if ($(window).width() < 640) {
      if (currentViewPosition < currentErrPosition) {
        $('html,body').animate({ scrollTop: currentErrPlusHeader }, 'slow');
      } else {
        $('form', this.node).mogo()._scrollTo('email_address');
      }
    }
  };
  this._onSignUp = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, response) {
      var formAnalyticsID, errorEmailTaken, errorDeactivatedUser, invalidEmail, currentErrPosition;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(response === 200)) {
                _context.next = 8;
                break;
              }

              _context.next = 3;
              return this._segmentTrackAccountCreated(data);

            case 3:

              if (this.promoData) {
                this.promoCode.delete();
              }
              // cookie referrer code existed when form was submitted
              if (this.referrerCode) {
                // valid code
                if (data && data.referred_by_id) {
                  this.analytics.pushEvent('referral', {
                    ReferralCode: [this.referrerCode]
                  });
                } else if (data && !data.referred_by_id) {
                  // code was not saved by BE - it must have been invalid
                  this.analytics.pushEvent('referral', {
                    ReferralCode: ['invalid - ' + this.referrerCode]
                  });
                }
                // delete the cookie, we're done with it
                this.referrerCode = null;
                Cookies.remove('referredBy', { path: '/' });
              }
              if (data && data.email_address) {
                formAnalyticsID = $('.js--signup-form').data('analytics-id');

                this.analytics.pushEvent('form-submit', {
                  FormID: [formAnalyticsID]
                });

                this._determineTargetAudience();

                this._session.setAuthToken(data.auth_token);
                this._session.setBearerToken(data.bearer_token);
                this._session.setRefreshToken(data.refresh_token);

                location.replace(this.paths.signup.verify);
              }
              _context.next = 23;
              break;

            case 8:
              if (!(response === 400)) {
                _context.next = 15;
                break;
              }

              errorEmailTaken = data.errors[0].key === 'member_service_email_taken';
              errorDeactivatedUser = data.errors[0].key === 'member_service_service_errors_account_deactivated';
              invalidEmail = data.errors[0].key === 'json_schema_error_did_not_match_all_of' && data.errors[0].msg === 'Provided email does not have a valid format';

              if (errorEmailTaken) {
                this._signUpForm.mogo().setErrorForValidationField('email_address', 'The signup email already exists!');
                this.analytics.pushEvent('form-errors', {
                  FormErrors: ['The signup email already exists']
                });

                // scroll to the error
                currentErrPosition = this._node.find('.js--username').offset().top;

                this._scrollTopToBottom(currentErrPosition);
              } else if (errorDeactivatedUser) {
                this._signUpForm.mogo().setErrorForValidationField('email_address', 'The signup email already exists!');
                this.analytics.pushEvent('form-errors', {
                  FormErrors: ['De-activated']
                });
              } else if (invalidEmail) {
                this._signUpForm.mogo().setErrorForValidationField('email_address', data.errors[0].msg);
              } else {
                $('#Notification').mogo().get();
              }
              _context.next = 22;
              break;

            case 15:
              if (!(response === 503)) {
                _context.next = 19;
                break;
              }

              // Account services offline - forward to maintenance page
              location.replace(this.paths.maintenance);
              _context.next = 22;
              break;

            case 19:
              if (!(data && data.errors)) {
                _context.next = 21;
                break;
              }

              return _context.abrupt('return', $('form', this.node).mogo().parseErrorObject(data.errors));

            case 21:
              $('#Notification').mogo().get();

            case 22:
              this._setButtonLoadState(false);

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this._onValidate = function (resultObj) {
    // - Scroll From top to bottom if the error is showing lower in the page
    if (resultObj.currentError != null && resultObj.currentError !== '') {
      var currentError = resultObj.currentError;

      var currentErrPosition = resultObj._resultObj[currentError].position.Y;
      this._scrollTopToBottom(currentErrPosition);
    }

    if (resultObj.count === 0) {
      // validate t&c checkbox after passed schema validation
      if (!this._validateAgreementCheckbox()) {
        return false;
      }
      var formAnalyticsID = $('form').data('analytics-id');

      var data = $('form', this.node).serializeFormToObj();

      var _window2 = window,
          analytics = _window2.analytics;
      // important: must check if user is available.
      // note: attaches segment's anonymous id to payload before sending to backend.
      // todo: remove full story events and logic when DV-3517 issue is resolved.

      var _debugData = null;

      try {
        if (analytics.user) {
          var anonymousID = analytics.user().anonymousId() || localStorage.getItem('ajs_anonymous_id');
          if (anonymousID) {
            data.anonymous_id = anonymousID;
          } else {
            _debugData = {
              name: 'Missing Anonymous ID',
              details: 'Anonymous ID not available.',
              segmentUser: analytics.user(),
              segmentData: analytics
            };
          }
        } else {
          _debugData = {
            name: 'Missing Anonymous ID',
            details: 'The object analytics.user is not accessible.',
            segmentData: analytics
          };
          if (localStorage.getItem('ajs_anonymous_id') !== null) {
            data.anonymous_id = localStorage.getItem('ajs_anonymous_id');
          }
        }
      } catch (error) {
        _debugData = {
          name: 'Missing Anonymous ID',
          details: 'Error detected.',
          error: error
        };
      }

      if (window.FS && _debugData !== null) {
        FS.event('Mogo App Debug', _debugData);
        FS.log('debug', _debugData);
      }

      // add promo code to payload if exists
      this.promoCode = new PromoCode();
      this.promoData = this.promoCode.get();
      if (this.promoData) {
        data.promo_code = this.promoData.promo_code;
      }

      // add referrer_code to payload if cookie exists:
      this.referrerCode = Cookies.getJSON('referredBy');
      if (this.referrerCode) {
        data.referrer_code = this.referrerCode;
      }

      // remove empty fields for non required fields entirely from payload sent to backend to avoid BE schema errors
      if (this.formVersion === 'Extended') {
        if (!data.first_name) delete data.first_name;
        if (!data.last_name) delete data.last_name;
        if (!data.birth_date) {
          delete data.birth_date;
        } else {
          // changes '/' to '-' in date format to make BE happy
          data.birth_date = this.dataSanitization.sanitizeDates(data.birth_date);
          // TODO: maybe _setupCalendar() below is already taking care of this?
        }

        if (!data.address) delete data.address;
        if (!data.street_name) delete data.street_name;
        if (!data.street_number) delete data.street_number;
        if (!data.apartment) delete data.apartment;
        if (!data.city) delete data.city;
        if (!data.country) delete data.country;
        if (!data.state_province) delete data.state_province;
        if (!data.postal_zip_code) delete data.postal_zip_code;
        if (!data.po_box) delete data.po_box;

        var province = this._$formInputs.province.val();
        var postalCode = this._$formInputs.postalCode.val();
        var firstCharPostalCode = postalCode.charAt(0);
        var notEmpty = province && postalCode && this.provincePostalCodeList[province];

        /*
          Check if postal code is from selected province. Based on this, 
          Set State, State Determines if request should be able to be 
          passed through to B.E or throw validation error. 
        */

        if (notEmpty && this.provincePostalCodeList[province].letter.includes(firstCharPostalCode)) {
          this.validPostalCode = true;
        }

        // Serialize Address Fields (Save all form values as string)
        var addressFieldValues = this._serializeAddressFields();

        // Compare serialized values to state, set field val / update data obj correspondingly,
        if (addressFieldValues === this.addressValues) {
          this._$formInputs.canadaPostId.val(this.canadaPostId);
          data.canada_post_id = this.canadaPostId;
        }

        // Explicitly pass in 'loans' as POI to payload (Since extended signup form is made for loans anyways)
        // https://mogofintech.atlassian.net/browse/ACCT-1028
        data.products_of_interest = ['loan'];
      }

      var endpoint = this.formVersion === 'Extended' ? '/accounts/signup_extended' : '/accounts';

      if (this.formVersion === 'Extended' && this._$formInputs.postalCode.val() && this._$formInputs.province.val() && !this.validPostalCode) {
        this._signUpForm.mogo().setErrorForValidationField('postal_zip_code', "The postal code doesn't look to be from the province you have provided");
      } else {
        var request = new APIRequest(endpoint, 'POST', data, this._onSignUp.bind(this));
        this._setButtonLoadState(true);
        data.analytics = this.analytics.constructData('Sign Up');
        request.send();
      }
    }

    return false;
  };

  // Determines the target Audience by
  // fuzzy matching the sign up url to certain product pages
  this._determineTargetAudience = function () {
    var loansUrl = ['/mogo-money', '/mogo-liquid', '/mogo-mini', '/personal-loans-canada', '/personal-loans-canada-v1'];
    var pathName = window.location.pathname;

    // Parse url to retrieve short pathname IE /mogo-money
    var referralOriginUrl = pathName ? pathName.substring(pathName.lastIndexOf('/')) : false;

    if (referralOriginUrl) {
      // Loans Theme
      if (checkUrls(loansUrl)) {
        Cookies.set('formdata_profileinfo_loanInterest', 'true', {
          expires: 30
        });
      }
    }

    // return true if the array item is apart of the original referral url
    function checkUrls(urlArray) {
      var isInUrl = false;

      urlArray.forEach(function (elem) {
        if (referralOriginUrl.includes(elem)) {
          isInUrl = true;
        }
      });

      return isInUrl;
    }
  };

  // This method only runs when this.formVersion === 'Extended'
  // (Its called from within a this.formVersion === 'Extended' conditional)
  this._setupCanadaPostAutocomplete = function () {
    if (this._$formInputs.address.length) {
      this._viewMaps['account.apartment'] = {
        set: function set(value) {
          if (!value) return '';
          return value;
        }
      };
    }

    var _this = this;

    var fields = [
    /*
      Binds Canada Post auto-complete functionality to our fields: 
        'element' key corresponds to the name attr of the filed in the pug
        'field' key corresponds to its corresponding canada post field name
    */

    // Address field - Search
    { element: 'address', field: '', mode: pca.fieldMode.SEARCH },
    // Remaining fields - Populate
    { element: 'street_number', field: 'BuildingNumber', mode: pca.fieldMode.POPULATE }, { element: 'street_name', field: 'Street', mode: pca.fieldMode.POPULATE }, { element: 'city', field: 'City', mode: pca.fieldMode.POPULATE }, { element: 'apartment', field: 'SubBuilding', mode: pca.fieldMode.POPULATE }, { element: 'po_box', field: 'POBoxNumber', mode: pca.fieldMode.POPULATE }, { element: 'state_province', field: 'ProvinceName', mode: pca.fieldMode.POPULATE }, { element: 'postal_zip_code', field: 'PostalCode', mode: pca.fieldMode.POPULATE }, { element: 'country', field: 'CountryName', mode: pca.fieldMode.POPULATE }];
    var options = {
      key: 'zg44-xp75-cn78-re32',
      suppressAutocomplete: true,
      showCountry: false,
      culture: 'en-ca',
      languagePreference: 'eng'
    };
    var control = new pca.Address(fields, options);

    /*
      This attribute gets un-set at some point, so ensure this is set, needed for
      disabling chrome auto-complete overlapping canada post autocomplete 
      Ref:
        https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
        https://github.com/bcgov/entity/issues/661
    */
    this._$formInputs.address.attr('autocomplete', 'chrome-off');

    control.listen('populate', function (address) {
      // Make the search address field update with the full formatted address
      _this._$formInputs.address.val(address.FormattedLine1);

      // If po box number present in CP address response
      // set street number as po box number
      // and street name as po box
      if (address.POBoxNumber && !address.BuildingNumber && !address.Street) {
        _this._$formInputs.streetNumber.val(address.POBoxNumber);
        _this._$formInputs.streetName.val('PO Box');
      }

      // Update select field to province provided by CP
      // CP doesn't fill out select html elements so need to do manually
      _this._$formInputs.province.val(address.ProvinceCode).change();

      _this.canadaPostId = address.Id;

      // Serialize Address Fields (Save all form values as string)
      // Set serialized values to state
      _this.addressValues = _this._serializeAddressFields();

      // Update text and show hidden
      _this._addressFieldsPrompt.removeClass('hide').text('Confirm your address');
      _this._$formInputs.hiddenAddressField.removeClass('hide');
    });

    // Click Cant find Address - Manually add address
    _this._cantFindAddressLink.click(function () {
      _this._$formInputs.address.val('');
      _this._addressFieldsPrompt.removeClass('hide').text('Manually type your address');
      _this._$formInputs.country.val('Canada');
      _this._$formInputs.hiddenAddressField.removeClass('hide');
    });

    // When province changes, reset old validations
    // From previous potential postal code validation messages
    this._$formInputs.province.change(function () {
      _this._form.mogo().resetValidationField('postal_zip_code');
    });
  };

  // Helper Method
  // Should only be called for
  // this.formVersion !== 'Extended'
  this._serializeAddressFields = function () {
    if (_this3.formVersion !== 'Extended') {
      console.warn('\n          This helper method should only be called for \n          this.formVersion === "Extended"');
      return false;
    }
    return $(_this3._form).find('\n        [name=street_name],\n        [name=street_number],\n        [name=city],\n        [name=apartment],\n        [name=state_province],\n        [name=postal_zip_code],\n        [name=country]\n      ').serialize();
  };
}